import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getBackUrl } from 'shared/lib/backUrl';
import { addWarningNotification } from 'shared/lib/notifications';
import { userportal as routes, invitationRoutePrefix } from 'shared/routes';

export const PublicOnlyRouteComponent = ({ component: Component, componentProps }) => {
  const { t } = useTranslation('common');
  const location = useLocation();
  const loggedIn = useSelector(state => state.auth.loggedIn);

  if (loggedIn === true) {
    if (location.pathname !== routes.login && !location.pathname.includes(invitationRoutePrefix)) {
      addWarningNotification(t('router.publicOnly'));
    }
    const backUrl = getBackUrl() || { pathname: routes.root };
    return <Navigate to={backUrl} replace />;
  }
  return <Component {...componentProps} />;
};

PublicOnlyRouteComponent.propTypes = {
  component: PropTypes.elementType.isRequired,
  componentProps: PropTypes.object,
};

PublicOnlyRouteComponent.defaultProps = {
  componentProps: {},
};

export default PublicOnlyRouteComponent;
